import { ACTIVE } from 'pages/focusItems/enums'
import apiService from './apiService'

const requestFocusItemList = (page, tab) => {
  let queryParams = {
    page: page,
    item_per_page: 50,
    selected: tab === ACTIVE
  }
  return apiService.get(URIS.focusItems, {params: queryParams})
}

const requestFocusItem = (id) => {
  return apiService.get(URIS_D('focusItem', id))
}

const requestFocusItemCreation = (focusItemPayload) => {
  return apiService.post(URIS.cmsFocusItem, focusItemPayload)
}

const requestDeleteFocusItem = (query) => {
  return apiService.delete(URIS_D('focusItem', query))
}

const getBundleTimers = () => {
  return apiService.get(URIS.flashFocusedItems)
}

const patchUpdateBundleTimers = (id, add = true) => {
  return apiService.patch(URIS_D('focusItem', id), { flash_sale: add })
}

const getProductCampaign = (id) => {
  return apiService.get(URIS_D('productCampaign', id))
}

const requestUpdateFocusItem = (focusItemPayload) => {
  return apiService.put(
    URIS_D('focusItem', focusItemPayload.id),
    focusItemPayload,
  )
}

const requestGetProductCampaign = (type) => {
  const params = { type }
  return apiService.get(URIS.productCampaign, { params })
}

export {
  requestFocusItemList,
  requestFocusItemCreation,
  requestDeleteFocusItem,
  requestUpdateFocusItem,
  requestGetProductCampaign,
  getBundleTimers,
  patchUpdateBundleTimers,
  requestFocusItem,
  getProductCampaign
}

const URIS_D = (url, param1) => {
  return {
    focusItem: `/v1/cms/focus-items/${param1}`,
    productCampaign: `/v1/products/product-campaign/${param1}`,
  }[url]
}

const URIS = {
  focusItems: '/v1/focus-items',
  cmsFocusItem: '/v1/cms/focus-items',
  productCampaign: '/v1/products/product-campaign/list',
  productCampaigns: '/v1/products/product-campaigns',
  flashFocusedItems: '/v1/cms/focus-items/flash',
}
